export const customDomainThemeModes = ['light', 'dark', 'both'] as const

type CustomDomainThemeMode = typeof customDomainThemeModes[number]
export default CustomDomainThemeMode
